export const TEXT = {
  TITLE: {id: 'account.menu.shipping'},
};
